import { BrowserRouter, Route, Routes } from "react-router-dom";

import HomePageTwo from "./pages/HomePageTwo";
import AddUserPage from "./pages/AddUserPage";
import ErrorPage from "./pages/ErrorPage";
import SignInPage from "./pages/SignInPage";
import UsersListPage from "./pages/UsersListPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import SignUpUserPage from "./pages/SignUpUsers";
import JobsPage from "./components/JobsPage";
import AddJobs from "./components/AddJob";
import SearchCompany from "./pages/SearchCompany";
import ViewBusinessProfile from "./pages/ViewBusinessProfile";
import AddAffiliates from "./components/AddAffiliates";
import AssignJob from "./components/AssignJob";
import AddUser from "./components/AddUser";
import UsersPage from "./components/UsersPage";
import UserProfile from "./components/UserProfile";
import EditJob from "./components/EditJob";
import EditAffiliates from "./components/EditAffiliates";
import EditUser from "./components/EditUser";
import ViewJob from "./components/ViewJob";
import JobStatusPage from "./components/JobStatusPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import InvoiceAddPage from "./pages/InvoiceAddPage";
import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import InvoiceEditPage from "./pages/InvoiceEditPage";
import AddDriverPage from "./components/AddDriverPage";
import DriversPage from "./components/DriversPage";
import ScheduleMaintenance from "./pages/ScheduleMaintenance";
import MaintenancePage from "./components/MaintenancePage";
import EditScheduleMaintenance from "./pages/EditScheduleMaintenance";
import ViewScheduleMaintenance from "./pages/ViewScheduleMaintenance";
import IssuesReport from "./components/IssuesReport";
import ViewIssueReport from "./pages/ViewIssueReport";
import ScheduleIssueMaintenance from "./pages/ScheduleIssueMaintenance";
import Payroll from "./pages/Payroll";
import AddPayroll from "./pages/AddPayroll";
import EditPayroll from "./pages/EditPayroll";
import ViewPayroll from "./pages/ViewPayRoll";
import DriverDashboard from "./components/DriverDashboard";
import AddTruck from "./components/AddTruckPage";
import TrucksPage from "./components/TrucksPage";
import ViewTruckPage from "./components/ViewTruckPage";
import DriverAssignmentPage from "./components/DriverAssignmentPage";
import ViewDriverPage from "./components/ViewDriverPage";
import CompanyPage from "./pages/CompanyPage";
import VehicleTruckLocation from "./components/ViewTruckLocationPage";
import IntegrationPage from "./pages/IntegrationPage";
import ReportsPage from "./pages/ReportsPage";
import InvoiceStatusPage from "./pages/InvoiceStatusPage";
import {MapboxProvider} from "./GoogleMapsContext";
import TourWidget from "./pages/TourWidget";
import SignUpPage from "./pages/SignUpPage"
import AssignJobDriver from "./components/AssignJobDriver";
import OpenTicketPage from "./components/OpenTicketPage";
import TicketPage from "./components/child/TicketPage";
import ViewTicketPage from "./components/child/ViewTicketPage";
import TicketPageForAdmin from "./components/child/TicketPageForAdmin";
import LiveChatPage from "./components/child/LiveChatPage";
import LiveTrackingPage from "./pages/LiveTrackingPage";
import ChatWidgetLoader from "./components/child/ChatBot";
import CreateInvoiceForJob from "./components/CreateInvoiceForJob";
import IncomePage from "./pages/IncomePage";
import ExpensePage from "./pages/ExpensePage";
import AddEmployeePage from "./pages/AddEmployeePage";
import AddLocationPage from "./components/AddLocationPage";
import LocationsPage from "./components/LocationPage";
import DepartmentsPage from "./components/DepartmentPage";
import AddWorkSchedulePage from "./pages/AddWorkSchedulePage";
import WorkSchedulesPage from "./pages/WorkSchedulesPage";
import EmployeesPage from "./pages/EmployeePage";
import EmployeeDetailPage from "./pages/EmployeeDetailPage";
import TimeOffPage from "./pages/TimeOffPage";
import RequestsPage from "./pages/RequestPage";
import TimesheetPage from "./pages/TimsheetPage";
import AddManualAttendancePage from "./pages/AddManualAttendancePage";
import RouteinDetail from "./pages/RoutineDetail";
import GeneratePayroll from "./pages/GeneratePayroll";
import PayrollListTable from "./components/PayrollListTable";
import EditPayrollAdvance from "./pages/EditPayrollAdvance";
import PayrollPreview from "./components/PayrollPreview";
import AccountPage from "./components/AccountPage";
import ExpenseLogPage from "./components/ExpenseLogPage";
import ExpenseTablePage from "./components/ExpenseTablePage";
import EditExpenseLogPage from "./components/EditExpenseLogPage";
import ViewExpensePageLog from "./components/ViewExpenseLogPage";
import ViewTruckExpensePage from "./components/ViewTruckExpensePage";
import EditTruckExpenseLog from "./components/EditTruckExpenseLog";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";


function App() {
  return (
    <MapboxProvider>
      

    <BrowserRouter
    future={{
      v7_relativeSplatPath:true,
      v7_startTransition:true
    }}
    >
    {/* <TourWidget/>  */}
      <RouteScrollToTop />
      <ChatWidgetLoader />
      <Routes
    
      >
        <Route exact path="/" element={<HomePageTwo />} />


        {/* SL */}
   
        <Route exact path="/add-staff" element={<AddEmployeePage />} />
        <Route exact path="/staff" element={<EmployeesPage />} />
        <Route exact path="/staff/view/:id" element={<EmployeeDetailPage />} />

        <Route exact path="/locations/add-location" element={<AddLocationPage />} />
        <Route exact path="/locations" element={<LocationsPage />} />
        <Route exact path="/time-off" element={<TimeOffPage />} />
        <Route exact path="/request" element={<RequestsPage />} />
        <Route exact path="/time-sheet" element={<TimesheetPage />} />
        <Route exact path="/time-sheet/routine" element={<RouteinDetail />} />
        <Route exact path="/manual-attendance" element={<AddManualAttendancePage />} />
        

        <Route exact path="/departments" element={<DepartmentsPage />} />
        <Route exact path="/work-schedule/add" element={<AddWorkSchedulePage />} />
        <Route exact path="/work-schedule" element={<WorkSchedulesPage />} />


        <Route exact path="/add-affiliates" element={<AddAffiliates />} />
        <Route exact path="/sign-up-user/:status" element={<SignUpUserPage />} />
        <Route exact path="/leads" element={<JobsPage />} />

        <Route exact path="/leads/:status" element={<JobStatusPage />} />
        <Route exact path="/add-lead" element={<AddJobs />} />
        <Route exact path="/live-tracking/:id" element={<LiveTrackingPage />} />
        <Route exact path="/lead-view/:id" element={<ViewJob />} />
        <Route exact path="/assign-job" element={<AssignJob />} />
        <Route exact path="/assign-job-to-driver" element={<AssignJobDriver />} />
        <Route exact path="/search-company" element={<SearchCompany />} />
        <Route exact path="/view-business-profile/:id" element={<ViewBusinessProfile />} />
        <Route exact path="/create-user" element={<AddUser />} />
        <Route exact path="/users" element={<UsersPage />} />
        <Route exact path="/view-profile" element={<UserProfile />} />
        <Route exact path="/add-user" element={<AddUserPage />} />
        <Route exact path="/lead-edit/:id" element={<EditJob />} />
        <Route exact path="/edit-user/:id" element={<EditUser />} />
        <Route exact path="/edit-affiliates/:id" element={<EditAffiliates />} />
        <Route exact path="/sign-in" element={<SignInPage />} />
        <Route exact path="/users-list" element={<UsersListPage />} />
        <Route exact path="/invoices" element={<InvoiceListPage />} />
        <Route exact path="/invoices/:status" element={<InvoiceStatusPage />} />
        <Route exact path="/add-invoice" element={<InvoiceAddPage />} />
        <Route exact path="/view-invoice/:id" element={<InvoicePreviewPage />} />
        <Route exact path="/edit-invoice/:id" element={<InvoiceEditPage />} />
        <Route exact path="/add-driver" element={<AddDriverPage />} />
        <Route exact path="/fleets-dashboard" element={<DriverDashboard />} />
        <Route exact path="/drivers" element={<DriversPage />} />
        <Route exact path="/drivers-view/:id" element={<ViewDriverPage />} />
        <Route exact path="/add-truck" element={<AddTruck />} />
        <Route exact path="/trucks" element={<TrucksPage />} />
        <Route exact path="/truck/location" element={<VehicleTruckLocation />} />
        <Route exact path="/truck-assignment" element={<DriverAssignmentPage />} />
        <Route exact path="/view-truck/:id" element={<ViewTruckPage />} />
        <Route exact path="/schedule-maintenance" element={<ScheduleMaintenance />} />
        <Route exact path="/maintenance-logs" element={<MaintenancePage />} />
        <Route exact path="/edit-schedule-maintenance/:id" element={<EditScheduleMaintenance />} />
        <Route exact path="/view-schedule-maintenance/:id" element={<ViewScheduleMaintenance />} />
        <Route exact path="/create-issue-schedule-maintenance/:id" element={<ScheduleIssueMaintenance />} />
        <Route exact path="/vehicle-default" element={<IssuesReport />} />
        <Route exact path="/view-issue-reported/:id" element={<ViewIssueReport />} />
        <Route exact path="/payroll/generate" element={<GeneratePayroll />} />
        <Route exact path="/payroll" element={<PayrollListTable />} />
        <Route exact path="/payroll" element={<PayrollListTable />} />
        <Route exact path="/create-payroll" element={<AddPayroll />} />
        {/* <Route exact path="/payroll/edit/:id" element={<EditPayroll />} /> */}
        <Route exact path="/payroll/edit/:month/:year/:emp_id" element={<EditPayrollAdvance />} />
        {/* <Route exact path="/payroll/view/:emp_id" element={<ViewPayroll />} /> */}
        <Route exact path="/payroll/view/:month/:year/:emp_id" element={<PayrollPreview />} />
        <Route exact path="/settings/profile" element={<CompanyPage />} />
        <Route exact path="/settings/integration" element={<IntegrationPage />} />
        <Route exact path="/reports" element={<ReportsPage />} />
        <Route exact path="/reports/income" element={<IncomePage />} />
        <Route exact path="/reports/expense" element={<ExpensePage />} />
        <Route exact path="/register" element={<SignUpPage />} />
        <Route exact path="/open-ticket" element={<OpenTicketPage />} />
        <Route exact path="/tickets" element={<TicketPage />} />
        <Route exact path="/tickets-for-admin" element={<TicketPageForAdmin />} />
        <Route exact path="/view-ticket/:id" element={<ViewTicketPage />} />
        <Route exact path="/create-invoice/:id" element={<CreateInvoiceForJob />} />
        <Route exact path="/accounts" element={<AccountPage />} />
        <Route exact path="/create-expense" element={<ExpenseLogPage />} />
        <Route exact path="/expense" element={<ExpenseTablePage />} />
        <Route exact path="/expense/edit/:id" element={<EditExpenseLogPage />} />
        <Route exact path="/expense/view/:id" element={<ViewExpensePageLog />} />
        <Route exact path="/truck-expense/view/:id" element={<ViewTruckExpensePage />} />
        <Route exact path="/truck-expense/edit/:id" element={<EditTruckExpenseLog />} />
        <Route exact path="/forgot-password" element={<ForgotPasswordPage />} />
        
        <Route exact path="/live-chat" element={<LiveChatPage />} />

        <Route exact path="*" element={<ErrorPage />} />


      </Routes>
    </BrowserRouter>
    </MapboxProvider>
  );
}

export default App;



